import axios from 'axios';
import StorageService from '../services/StorageService';

// Configurar o interceptor de resposta
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Se o erro for 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      // Limpar dados de autenticação
      StorageService.clearAuth();
      // Redirecionar para a página de login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios;
